<template>
  <el-dialog
    title="找回密码"
    :visible.sync="dialogVisible"
    width="400px"
    class="retrieve-password"
    center
    :close-on-click-modal="true"
  >
    <el-form ref="form" :model="form" :rules="formRules" size="small">
      <el-form-item prop="email">
        <el-input
          v-model="form.email"
          maxlength="50"
          placeholder="请输入注册邮箱"
          @keyup.enter="handleLogin"
        >
          <i slot="prefix" class="el-input__icon">
            <img src="@/assets/images/Icon/user.svg" alt="">
          </i>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="form.password"
          maxlength="20"
          show-password
          placeholder="请输入新密码"
          @keyup.enter="handleLogin"
        >
          <i slot="prefix" class="el-input__icon">
            <img src="@/assets/images/Icon/password.svg" alt="">
          </i>
        </el-input>
      </el-form-item>
      <el-form-item prop="captcha">
        <el-input
          v-model="form.captcha"
          placeholder="请输入验证码"
          maxlength="10"
          style="width: 240px"
        >
        <i slot="prefix" class="el-input__icon">
          <img src="@/assets/images/Icon/capture.svg" alt="">
        </i>
        </el-input>
        <p class="captcha-img" @click="getCaptcha" v-loading="isGettingCode">
          <img :src="capSrc" />
        </p>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button style="width:100%;" type="primary" @click="validateForm" :loading="isSubmiting">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formRules } from '@/utils/helper.js';
import { loginApi } from '@/api/api'
export default {
  data () {
    return {
      dialogVisible: false,
      form: {
        email: '',
        password: '',
        captcha: ''
      },
      isSubmiting: false,
      isGettingCode: false,
      capSrc: '',
      formRules: {
        email: [
          { validator: formRules.spaceValidate('邮箱') }
        ],
        password: [
          { validator: formRules.passwordValid }
        ],
        captcha: [
          { required: true, message: '验证码不能为空' }
        ]
      }
    };
  },
  mounted () {},
  methods: {
    validateForm () {
      this.$refs.form.validate((valid, invalidFields) => {
        if (valid) {
          this.isSubmiting = true;
          this.submitData();
        }
      });
    },
    submitData () {
      let params = {
        password: this.form.password,
        email: this.form.email,
        code: this.form.captcha
      };
      loginApi
        .forgetPassword(params)
        .then((res) => {
          this.isSubmiting = false;
          if (res.status === 10000) {
            this.$message.success('密码修改提交成功!');
            // this.logout();
            // this.$router.push('/login')
            this.$emit('modify-success', this.form.email)
            this.dialogVisible = false
          } else {
            this.getCaptcha();
            this.$message.error(res.message);
          }
        })
    },
    showDialog () {
      this.dialogVisible = true;
      this.$refs.form && this.$refs.form.resetFields()
      this.getCaptcha();
    },
    // 用户退出
    // logout () {
    // login.logout().then((res) => {
    //   if (res.status === 2000) {
    //     this.$router.push('/login');
    //   } else {
    //     this.$message.error(statusToText(res.status));
    //   }
    // });
    // },
    getCaptcha () {
      this.isGettingCode = true;
      loginApi
        .getCaptcha()
        .then(({ data }) => {
          this.isGettingCode = false;
          if (data.status === 10000) {
            this.capSrc = data.data.images; // "data:image/jpeg;base64," + res;
            // this.key = res.data.key;
          } else {
            this.$message.error(data.message);
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
};
</script>

<style lang="scss" scoped>
.captcha-img {
  display: inline-block;
  line-height: 12px;
  width: 110px;
  vertical-align: middle;
  padding-left: 10px;
  & > img{
    width: 100%;
  }
}
.retrieve-password{
  ::v-deep .el-dialog{
    .el-dialog__header{
      text-align: left;
      background: #698EF7;
      padding: 10px 20px;
      .el-dialog__title{
        color: #fff;
      }
      .el-dialog__headerbtn .el-dialog__close{
        color: #fff;
      }
      .el-dialog__headerbtn{
        top: 15px;
      }
    }
    .el-dialog__body{
      padding: 25px 25px 0;
    }

  }
  .el-input__icon{
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
